import { render, staticRenderFns } from "./FlatpickerComponent.vue?vue&type=template&id=dd8dce98&"
import script from "./FlatpickerComponent.vue?vue&type=script&lang=js&"
export * from "./FlatpickerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports